<template>
	<router-view></router-view>
</template>

<script>
    export default {
        name: "user-index"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/user/UserIndex.vue